import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';

import { RootStateBase } from '../../../store/baseStore';

import * as S from './styles'

import { Button } from '../../../components/Button';
import { Icon } from '@iconify/react';
import { RemoveErrors } from '../../../store/base/action/baseAction';
import { StateType } from 'domain/types/base/base';
import { View } from "../../../components/Basic/View/view";
import { Modal, ModalContent } from "../../../components/Modal";


const connector = connectUtil(
	(state: RootStateBase) => ({
		error: state.BaseReducer.Error,
	}),
	{ RemoveErrors }
);

export interface LoadingProps extends PropsFromRedux<typeof connector> {
}

function MasterError(props: LoadingProps) {
	const error = props.error.filter((e) => e.CallBack);
	const errorLastIndex = error.length - 1;
	const callBackText = typeof error[errorLastIndex]?.CallBack !== 'function' ? error[errorLastIndex]?.CallBack?.CallBackText : "Ok!";
	// Check if in development mode
	const isDev = process.env.NODE_ENV === 'development';

	function handleClick() {
		error.forEach((s) => {
			if (typeof s?.CallBack === 'function') {
				s.CallBack();
			} else {
				s?.CallBack.CallBack();
			}
		})
		props.RemoveErrors()
	}

	return (
		<Modal open={props.error.find((e) => e.Type == StateType.Master) ? true : false}>
			<ModalContent 
				overlayStyle={{
					opacity: 0.9, 
					backgroundColor: 'rgba(0, 0, 0, 0.3)',
					backdropFilter: 'blur(8px)'
				}}
				contentStyle={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					padding: '20px',
					backgroundColor: 'transparent',
					boxShadow: 'none'
				}}
			>
				<S.ErroContainer $variant="error">
					<S.IconContainer $variant="error">
						<Icon 
							icon="mdi:alert-circle" 
							style={{ 
								fontSize: '72px', 
								color: '#ef4444',
								position: 'relative',
								zIndex: 1,
								filter: 'drop-shadow(0 4px 12px rgba(239, 68, 68, 0.3))'
							}} 
						/>
					</S.IconContainer>
					<S.Title $variant="error">
						Ocorreu um erro
					</S.Title>
					<S.Text>
						{isDev ? (
							// In development mode, show all error messages
							props.error
								.filter((error) => error.Name !== 'NETWORK')
								.map((m, index) => (
									<View key={index}>{m.Message}</View>
								))
						) : (
							// In production mode, show only the last error message
							props.error
								.filter((error) => error.Name !== 'NETWORK')
								.slice(-1)
								.map((m, index) => (
									<View key={index}>{m.Message}</View>
								))
						)}
					</S.Text>
					<S.ButtonContainer>
						<Button 
							full={true} 
							onClick={handleClick} 
							iconPosition='left' 
							size='lg'
							style={{ 
								borderRadius: '12px', 
								height: '52px', 
								fontSize: '16px', 
								fontWeight: '600',
								backgroundColor: '#ef4444',
								borderColor: '#ef4444',
								transition: 'all 200ms ease-in-out',
								boxShadow: '0 8px 24px rgba(239, 68, 68, 0.25)',
								gap: '8px'
							}}
						>
							<Icon icon="mdi:check" height="20px" color={"white"} />
							{callBackText}
						</Button>
					</S.ButtonContainer>
				</S.ErroContainer>
			</ModalContent>
		</Modal>
	)
}

export default connector(MasterError);
